/* Lunya PLP linked colors: templates carry each product's featured image.
 * Keep previews separate from Symmetry's gallery, links and Quick Buy state.
 * Custom-element connection handles filtering, Load More and editor replacement.
 */
(() => {
  if (customElements.get('lunya-swatch-preview')) return;

  class LunyaSwatchPreview extends HTMLElement {
    connectedCallback() {
      if (!document.body.matches('.lunya-brand.template-collection')) return;
      this.imageHost = this.closest('product-block')?.querySelector('.image-label-wrap > div, .image-cont > .placeholder-image');
      if (!this.imageHost) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('pointerover', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = event.target.closest('.lunya-plp-colourways__link');
        this.updatePreview();
      }, options);
      this.addEventListener('pointerout', (event) => {
        if (event.pointerType !== 'mouse') return;
        const next = event.relatedTarget?.closest?.('.lunya-plp-colourways__link');
        this.hovered = next && this.contains(next) ? next : null;
        this.updatePreview();
      }, options);
      this.addEventListener('focusin', (event) => {
        // Touch/click focus must keep the first tap's native navigation behavior.
        this.focused = event.target.matches(':focus-visible')
          ? event.target.closest('.lunya-plp-colourways__link') : null;
        // A stationary pointer must not override a new keyboard selection.
        if (this.focused) this.hovered = null;
        this.updatePreview();
      }, options);
      this.addEventListener('focusout', () => {
        this.focused = null;
        this.updatePreview();
      }, options);
    }

    updatePreview() {
      const swatch = this.hovered || this.focused;
      if (swatch === this.swatch) return;
      this.clearPreview();
      this.swatch = swatch;
      const template = swatch?.querySelector('template[data-lunya-preview]');
      if (!template) return;
      const frame = template.content.firstElementChild.cloneNode(true);
      const image = frame.querySelector('img');
      if (!image) return;
      this.frame = frame;
      this.previewEvents = new AbortController();
      image.alt = '';
      const show = () => {
        if (this.isConnected && this.frame === frame && image.naturalWidth) frame.hidden = false;
      };
      image.addEventListener('load', show, { once: true, signal: this.previewEvents.signal });
      image.addEventListener('error', () => {
        if (this.frame === frame) this.clearPreview();
      }, { once: true, signal: this.previewEvents.signal });
      this.imageHost.append(frame);
      if (image.complete) show();
    }

    clearPreview() {
      this.previewEvents?.abort();
      this.frame?.remove();
      this.frame = null;
      this.swatch = null;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.clearPreview();
      this.hovered = null;
      this.focused = null;
    }
  }

  customElements.define('lunya-swatch-preview', LunyaSwatchPreview);
})();
